import { ConversationView, AssignedParticipantUnreadInfo } from '@mark43/cad-api';
import { ConversationKey } from '../models';

// get the next index for an array, wrapping to the start if reached the end
export const getNextIndex = (array: unknown[], currentIndex: number) => {
    const nextIndex = currentIndex >= array.length - 1 ? 0 : currentIndex + 1;
    return nextIndex;
};

// get the previous index for an array, wrapping to the end if reached the start
export const getPreviousIndex = (array: unknown[], currentIndex: number) => {
    const previousIndex = currentIndex <= 0 ? array.length - 1 : currentIndex - 1;
    return previousIndex;
};

export const sortConversationKeys = (
    conversations?: Record<number, ConversationView>,
    myAssignedParticipantUnreadInfoByConversationIdMap?: Record<
        number,
        AssignedParticipantUnreadInfo
    >
) => (a: ConversationKey, b: ConversationKey) => {
    const conversationA = conversations?.[a.conversationId];
    const conversationB = conversations?.[b.conversationId];
    const aId = conversationA?.newestMessageId ?? 0;
    const bId = conversationB?.newestMessageId ?? 0;
    const aHasUnreadMessage = !!myAssignedParticipantUnreadInfoByConversationIdMap?.[
        a.conversationId
    ]?.unreadCount;
    const bHasUnreadMessage = !!myAssignedParticipantUnreadInfoByConversationIdMap?.[
        b.conversationId
    ]?.unreadCount;

    if (aHasUnreadMessage === bHasUnreadMessage) {
        if (aId > bId) {
            return -1;
        } else if (aId < bId) {
            return 1;
        } else {
            return 0;
        }
    }
    if (aHasUnreadMessage) {
        return -1;
    }
    return 1;
};
